import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Modal from 'components/CncUI/Modal';
import RadioCard from 'components/CncUI/RadioCard';
import Button from 'components/CncUI/Button';
import Typography from 'components/CncUI/Typography';

import ExistingCard from '../Shared/ExistingCard';

import useSnackbar from 'hooks/useSnackbar';

const useStyles = makeStyles(() => ({
  center: {
    textAlign: 'center',
  },
  existing: {
    '& .cncui-modal-content': {
      padding: '48px 20px',
      overflowX: 'hidden',
    },
  },
}));

const SelectLoanOut = ({ state, existing, updateParent, onSave }) => {
  const classes = useStyles();
  const notify = useSnackbar();
  const [selected, setSelected] = useState('');

  return (
    <Modal fullScreen open={state.showExisting} className={classes.existing}>
      <Modal.Content>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography h3 center noMargin>
                  Select a loan-out
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography short body2 center noMargin>
                  Select which loan-out profile you would like to have on file,
                  or click “Add new” to use a one not shown below.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={7}>
              <Grid item xs={12}>
                <RadioCard.Group
                  value={selected}
                  onChange={e => setSelected(e.target.value)}
                >
                  <Grid
                    container
                    spacing={2}
                    justify="center"
                    alignItems="center"
                  >
                    {existing.map((existing, i) => (
                      <Grid item key={`ExistingCard-${i}`}>
                        <ExistingCard
                          data={existing}
                          value={`${i}`}
                          disabled={state.saving}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </RadioCard.Group>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2} justify="center">
                  <Grid item>
                    <Button
                      secondary
                      disabled={state.saving}
                      width={235}
                      onClick={() =>
                        updateParent({ showExisting: false, edit: true })
                      }
                    >
                      Add new
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      width={235}
                      loading={state.saving}
                      disabled={!selected}
                      onClick={() => {
                        const data = existing[selected];
                        updateParent({ saving: true });
                        onSave({
                          source: 'profile',
                          dataSource: data.dataSource,
                          dbCode: data.dbCode,
                          taxId: data.taxId,
                          name: data.name,
                          type: data.type,
                          address: data.address,
                          city: data.city,
                          state: data.state,
                          country: data.country,
                          zipCode: data.zipCode,
                          createdAt: data.createdAt,
                        })
                          .then(() => {
                            updateParent({
                              saving: false,
                              reload: true,
                              showExisting: false,
                            });
                          })
                          .catch(err => {
                            logger.error(
                              'Could not save existing loanout',
                              err,
                            );
                            updateParent({ saving: false });
                            notify({
                              type: 'error',
                              message:
                                'Could not save loanout, please try again',
                            });
                          });
                      }}
                    >
                      Use selected
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.center}>
            <Button
              tertiary
              disabled={state.saving}
              onClick={() => updateParent({ showExisting: false })}
            >
              I'll decide later
            </Button>
          </Grid>
        </Grid>
      </Modal.Content>
    </Modal>
  );
};

export default SelectLoanOut;
